module.exports = __webpack_public_path__ + "img/BANNERS_BIG-04.a9466cb8.jpg";